import { render, staticRenderFns } from "./ybHistory.vue?vue&type=template&id=049d63d0&scoped=true"
import script from "./ybHistory.vue?vue&type=script&lang=js"
export * from "./ybHistory.vue?vue&type=script&lang=js"
import style0 from "./ybHistory.vue?vue&type=style&index=0&id=049d63d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d63d0",
  null
  
)

export default component.exports